import { useAuthGetters } from '@/store'
import { computed } from '@vue/composition-api'

const { currentUser } = useAuthGetters()
const locale = computed(() => currentUser.value.locale)

export const formatDecimal = (input: number, maximumFractionDigits = 2) => {
  return input.toLocaleString(locale.value, { maximumFractionDigits })
}
